<adapt-activity-section-collapsible [section]="section"
                                    [count]="todoItems.length + inProgressItems.length"
                                    [totalCount]="activityGroup.totalCount"
                                    [countTooltip]="countTooltip"
                                    [fallbackText]="fallbackText"
                                    [isLoading]="isLoading"
                                    [error]="error">
    <div adapt-collapsible-header-action-right
         class="d-flex flex-row align-items-center gap-1">
        <button class="btn btn-primary btn-pill"
                [adaptButtonIcon]="blurPrivateActions ? 'fal fa-eye' : 'fal fa-eye-slash'"
                adaptTooltip="{{blurPrivateActions ? 'Show' : 'Blur'}} private actions"
                (click)="toggleBlurPrivateActions($event)"
                [attr.data-test]="'blur-private-actions-button-' + (blurPrivateActions ? 'show' : 'blur')"></button>
        <adapt-menu [items]="itemMenu"></adapt-menu>
    </div>

    <div *ngIf="todoItems.length > 0 || inProgressItems.length > 0"
         class="item pt-3 flex-grow-1">
        <div *ngIf="todoItems.length > 0"
             data-test="activity-actions-todo">
            <h4><span class="item-status-badge-todo"></span> To do ({{todoItems.length}}) </h4>
            <div class="kanban-cards">
                <div *ngFor="let item of todoItems"
                     class="kanban-card">
                    <adapt-kanban-card [item]="item"
                                       [draggable]="false"
                                       [showAssignee]="false"
                                       [highlight]="item.extensions.isOverdue"
                                       [blurSensitiveContent]="blurPrivateActions"></adapt-kanban-card>
                </div>
            </div>
        </div>

        <div *ngIf="inProgressItems.length > 0"
             data-test="activity-actions-inprogress">
            <h4><span class="item-status-badge-inprogress"></span> In progress ({{inProgressItems.length}})</h4>
            <div class="kanban-cards">
                <div *ngFor="let item of inProgressItems"
                     class="kanban-card">
                    <adapt-kanban-card [item]="item"
                                       [draggable]="false"
                                       [showAssignee]="false"
                                       [highlight]="item.extensions.isOverdue"
                                       [blurSensitiveContent]="blurPrivateActions"></adapt-kanban-card>
                </div>
            </div>
        </div>
    </div>
</adapt-activity-section-collapsible>
